import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { SortField } from '~/utils/types/common';
import { DEFAULT_PAGE, ROWS_PER_PAGE } from '~/utils/constants/common';

import { handleGetEstimateTemplates } from './estimateTemplateThunk';
import { IEstimateTemplate } from '~/utils/interface/estimate-template';

export interface estimateTemplateState {
  estimateTemplates: Array<IEstimateTemplate>;
  filter: IFilter;
  currentPage: number;
  totalPages: number;
  needRefreshData: boolean;
  selectedIds: Array<string>;
  openAlertDelete: boolean;
  menuSelectedId: string | undefined;
}

interface IFilter {
  page?: number;
  limit?: number;
  sort?: Array<SortField>;
  type?: string;
}

const initialState: estimateTemplateState = {
  estimateTemplates: [],
  currentPage: DEFAULT_PAGE,
  totalPages: 0,
  needRefreshData: false,
  filter: {
    page: 1,
    limit: ROWS_PER_PAGE,
    sort: [],
    type: '',
  },
  selectedIds: [],
  openAlertDelete: false,
  menuSelectedId: undefined,
};

const estimateTemplateSlice = createSlice({
  name: 'estimateTemplate',
  initialState,
  reducers: {
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
    setFilter(state, action: PayloadAction<IFilter>) {
      state.filter = { ...state.filter, ...action.payload };
    },
    changeSelectedIds(state, action: PayloadAction<Array<string>>) {
      state.selectedIds = [...action.payload];
    },
    changeOpenAlertDelete(state, action: PayloadAction<boolean>) {
      state.openAlertDelete = action.payload;
      if (!state.openAlertDelete) {
        state.menuSelectedId = undefined;
      }
    },
    changeMenuSelectId(state, action: PayloadAction<string | undefined>) {
      state.menuSelectedId = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleGetEstimateTemplates.pending, (_state, _action) => {})
      .addCase(handleGetEstimateTemplates.fulfilled, (state, action) => {
        state.estimateTemplates = [...action.payload.responses];
        state.currentPage = action.payload.pagination.page;
        state.totalPages = action.payload.pagination.totalPages;
        state.needRefreshData = false;
      })
      .addCase(handleGetEstimateTemplates.rejected, (_state, _action) => {});
  },
});

export const estimateTemplateActions = estimateTemplateSlice.actions;

const estimateTemplateReducer = estimateTemplateSlice.reducer;
export default estimateTemplateReducer;
